import React from 'react'
import PropTypes from 'prop-types'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-mysql'
import 'ace-builds/src-noconflict/theme-xcode'

function DqlEditor ({ name, value, onChange, readOnly, minLines, maxLines }) {
  return (
    <AceEditor
      name={name || 'dql-editor'}
      mode='mysql'
      theme='xcode'
      value={value}
      onChange={onChange}
      readOnly={readOnly}
      width='100%'
      minLines={minLines || 6}
      maxLines={maxLines || 20}
      fontSize={13}
      showPrintMargin={false}
      showGutter
      highlightActiveLine={!readOnly}
      setOptions={{
        showLineNumbers: true,
        tabSize: 2,
        useWorker: false
      }}
    />
  )
}

DqlEditor.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  minLines: PropTypes.number,
  maxLines: PropTypes.number
}

export default DqlEditor
